import { action, computed, observable } from 'mobx';

/**
 * Tracks whether an agentic full-screen surface is currently mounted —
 * the Smart Editor `FlowShell`, the Exception `ExceptionShell`, or the
 * standalone `AgenticEntryPage`.
 *
 * The global Policy Assistant FAB reads `isActive` and hides itself while any
 * such surface is mounted, so the general-purpose assistant never overlaps the
 * dedicated agentic experiences.
 *
 * Ref-counted (not a boolean) so that overlapping mount/unmount during a route
 * transition — where one shell mounts before the previous unmounts — never
 * briefly re-shows the FAB.
 */
class AgenticSurfaceStore {
  @observable private count = 0;

  @computed get isActive(): boolean {
    return this.count > 0;
  }

  /** Called by an agentic shell on mount. */
  @action enter(): void {
    this.count += 1;
  }

  /** Called by an agentic shell on unmount. Never drops below zero. */
  @action exit(): void {
    if (this.count > 0) this.count -= 1;
  }
}

/** App-wide singleton — one count shared across all agentic surfaces. */
export const agenticSurfaceStore = new AgenticSurfaceStore();
